import { Injectable } from '@angular/core';
import { FirestoreService } from './firestore/firestore.service';
import { Globals } from '../globals';
import { Observable } from 'rxjs';

export interface ExpenseCategory{
  id?: string;
  active: boolean;
  name: string;
  shortName: string;
}

@Injectable()
export class ExpenseCategoryService {

  collection: string;

  constructor(
    private afh: FirestoreService,
  ) {
    this.collection = Globals.EXPENSE_CATEGORY_COLLECTION;
  }

  /**
   * Get all expenseCategorys with references
   * @return {Observable} Arrays of expenseCategorys
   */
  getExpenseCategorys(): Observable<ExpenseCategory[]> {
  return this.afh.colWithIds$(this.collection, ref => ref.orderBy('name', 'asc')/* .where('active', '==', true) */ );
  }

  /**
  * Get expenseCategory data
  * @param {string} sid - The id of the expenseCategory
  * @return {Observable} The ExpenseCategory Object
  */
  getExpenseCategory(sid: string): Observable<ExpenseCategory> {
    return this.afh.docWithIds$(this.collection + '/' + sid);
  }

  /**
  * Create new expenseCategory
  * @param {ExpenseCategory} expenseCategory - The data of the expenseCategory
  */
  addExpenseCategory(expenseCategory: ExpenseCategory) {
    this.afh.add(`${this.collection}`, expenseCategory);
  }

  /**
   * Update current expenseCategory
   * @param {string} sid  - The id of the expenseCategory
   * @param {ExpenseCategory} expenseCategory - The data of the expenseCategory
   */
  updateExpenseCategory(sid: string, expenseCategory: Partial<ExpenseCategory>) {
    this.afh.update(`${this.collection}/${sid}`, expenseCategory);
  }

  /**
   * Delete current expenseCategory
   * @param {string} sid - The id of the expenseCategory
   */
  deleteExpenseCategory(sid: string) {
    this.afh.delete(`${this.collection}/${sid}`);
  }

  getDocRef(docId: string){
    return this.afh.doc(`${this.collection}/${docId}`).ref;
  }
}